module.exports = __webpack_public_path__ + "img/xc.037a33b3.jpg";